// LM-45: footer 'Cookie preferences' bağlantısı → Shopify gizlilik tercihleri
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#cookie-preferences"]');
  if (!a) return;
  e.preventDefault();
  try {
    if (window.Shopify && Shopify.privacy && Shopify.privacy.showPreferences) { Shopify.privacy.showPreferences(); return; }
    if (window.privacyBanner && window.privacyBanner.showPreferences) { window.privacyBanner.showPreferences(); return; }
  } catch (err) {}
  window.location.href = '/policies/privacy-policy';
});

// LM59-POPUP BASLA
// LM-59 (19 Eki 2026, Atamert): Collectors Circle popup'ı (Klaviyo SFMUaS) çerez seçiminden SONRA açılır.
// Neden: mobil ilk ziyarette Shopify çerez bandı popup'ın altını (onay cümlesi, Privacy linki, Not now) kapatıyordu.
// Klaviyo formu 'Only show on custom trigger' modunda; özel tetik Klaviyo'nun ziyaretçi kurallarını geçersiz kıldığı için
// eski tetikler burada: 1 sn gecikme (K-093) · kayıt olana bir daha yok · tanınan profile yok · kapatınca 3 gün yok (LM-17 m.5).
// Bant gösterilmeyen bölgede ya da seçim önceden yapılmışsa popup sayfa açılışından 1 sn sonra gelir.
// Kaynak bu dosya; assets/lm-brand.js sonuna lm59_parity.py popup yazar.
(function () {
  var FORM = 'SFMUaS', DELAY = 1000, SNOOZE_MS = 3 * 864e5, KEY = 'lm_circle_popup';
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.formId !== FORM) return;
    var s = load();
    if (d.type === 'submit') s.done = 1;
    else if (d.type === 'close') s.closed = Date.now();
    else return;
    save(s);
  });
  function suppressed() {
    var s = load();
    return !!(s.done || (s.closed && Date.now() - s.closed < SNOOZE_MS));
  }
  var queued = false;
  function open() {
    if (queued || suppressed()) return;
    queued = true;
    setTimeout(function () {
      if (suppressed()) return;
      var go = function () { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', FORM]); };
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function') {
        Promise.resolve(k.isIdentified()).then(function (known) { if (!known) go(); }, go);
      } else { go(); }
    }, DELAY);
  }
  // shouldShowBanner() bölgenin bant isteyip istemediğini söyler, seçimden sonra da true kalır (19 Eki ölçümü);
  // seçim bekleniyor mu sorusunu currentVisitorConsent cevaplar ('' = henüz seçim yok)
  function pending(cp) {
    if (!cp.shouldShowBanner()) return false;
    var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
    if (c) return !c.marketing && !c.analytics && !c.preferences;
    return typeof cp.getTrackingConsent === 'function' && cp.getTrackingConsent() === 'no_interaction';
  }
  // true = karar verildi (popup sıraya alındı ya da seçim bekleniyor), false = gizlilik API'si henüz yüklenmedi
  function decide() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.shouldShowBanner !== 'function') return false;
    if (!pending(cp)) open();
    return true;
  }
  document.addEventListener('visitorConsentCollected', open);
  if (!decide() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) decide(); });
  }
})();
// LM59-POPUP BITTI
